/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Blog_DescInputs */

const en_directory_home_blog_desc = /** @type {(inputs: Directory_Home_Blog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How six dimensions turn a crowded AI market into an evidence-based shortlist — and what changes week to week.`)
};

const zh_directory_home_blog_desc = /** @type {(inputs: Directory_Home_Blog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`六个维度如何把拥挤的 AI 市场变成一份有据可依的短名单——以及每周有哪些变化。`)
};

/**
* | output |
* | --- |
* | "How six dimensions turn a crowded AI market into an evidence-based shortlist — and what changes week to week." |
*
* @param {Directory_Home_Blog_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_blog_desc = /** @type {((inputs?: Directory_Home_Blog_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Blog_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_blog_desc(inputs)
	return zh_directory_home_blog_desc(inputs)
});
export { directory_home_blog_desc as "directory.home.blog_desc" }